import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#97FA00",
    "col1n": "#86DE00",
    "col2n": "#FFFFFF"
}
function ShiMot126({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M46.4 10.25q0-4.25-3-7.25t-7.25-3q-4.3 0-7.3 3-1.05 1-1.65 2.2-.05.1-.1.25-1.85-.35-3.85-.35-2.1 0-4 .4-.1-.15-.15-.3-.7-1.1-1.55-1.95-3-3-7.25-3-4.3 0-7.3 3T0 10.5q0 4.3 3 7.25.45.45 1.05.9.1.1.25.2-.75 2.3-.85 4.9-.05.55-.05 1.15 0 1.9.3 3.65.55 3.3 2.2 6.15h.05q1.3 2.3 3.3 4.3l.4.4q5.7 5.4 13.6 5.4 8.25 0 14-5.8 5-4.95 5.75-11.65.1-1.15.1-2.35v-1.25q-.1-.75-.15-1.45-.25-1.95-.85-3.7.2-.05.35-.2.45-.45.95-.9 3-2.9 3-7.25z"
                    id="ShiMot126__Symbol_120_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M29.85 12.85q0-5.3-4.45-9.1Q21.05 0 14.95 0 8.8 0 4.35 3.75 0 7.55 0 12.85q0 .5.05 1 .4.45.9.95l.4.4q5.7 5.4 13.6 5.4 8.25 0 14-5.8.45-.45.85-.9.05-.5.05-1.05z"
                    id="ShiMot126__Symbol_118_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M13.8 2.6Q11.45.25 8.1.25 4.7.25 2.35 2.6T0 8.3q0 3.4 2.35 5.7.25.25.6.55 1.45-3.2 4.1-5.85 3.4-3.45 7.8-4.85-.5-.7-1.05-1.25m25.85-.25Q37.3 0 33.95 0q-3.4 0-5.75 2.35-.7.65-1.15 1.45 4.2 1.25 7.6 4.5l.4.4q2 2 3.35 4.3.35.65.65 1.3.3-.3.6-.55v-.05Q42 11.4 42 8.05q0-3.35-2.35-5.7z"
                    id="ShiMot126__Symbol_119_0_Layer0_0_FILL"
                />
                <path
                    d="M194.4 281.8h.05q-.95-.6-2.1-.65h-.05q-1.25.05-2.1.65-.45.25-.7.3-.05 0-.1.05-.25.05-.7.05-.4 0-.75-.15l-.05-.05q-.45-.2-.95-.9-.2-.2-.4-.25-.25-.05-.45.15-.2.15-.25.4-.05.2.15.45.75.95 1.4 1.25.6.3 1.3.3.65 0 1-.1.35-.05 1.1-.45l.05-.05q.6-.4 1.45-.45.8.05 1.5.45v.05q.7.4 1.05.45h-.05q.4.1 1.05.1.75 0 1.4-.3.55-.3 1.45-1.25.15-.2.15-.4 0-.25-.2-.4-.2-.2-.4-.2-.25 0-.4.2-.75.75-1.15 1-.4.15-.85.15-.45 0-.7-.05l-.05-.05q-.2-.05-.7-.3z"
                    id="ShiMot126__Layer1_0_FILL"
                />
                <path
                    d="M206.75 266.9q-1.05 0-1.8.95-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3-.7-.95-1.75-.95m-28.45 0q-1.05 0-1.8.95-.4.6-.6 1.3-.1.45-.1 1 0 1.35.7 2.25.75.95 1.8.95t1.75-.95q.75-.9.75-2.25 0-.55-.1-1-.2-.7-.65-1.3-.7-.95-1.75-.95z"
                    id="ShiMot126__Layer1_1_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiMot126__Symbol_120_0_Layer0_0_FILL"
                transform="translate(169.3 263.05)"
                id="ShiMot126__col1n"
            />
            <use
                xlinkHref="#ShiMot126__Symbol_118_0_Layer0_0_FILL"
                transform="translate(177.6 287.25)"
                id="ShiMot126__col1l"
            />
            <use
                xlinkHref="#ShiMot126__Symbol_119_0_Layer0_0_FILL"
                transform="translate(171.5 265.25)"
                id="ShiMot126__col2n"
            />
            <use xlinkHref="#ShiMot126__Layer1_0_FILL" />
            <use xlinkHref="#ShiMot126__Layer1_1_FILL" />
        </g></g>
    )
}
export default ShiMot126
